module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("صرخة ضمير ونغمة قلب")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#حبر-العناقيد"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حبر العناقيد")])])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#الإهداء"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#حقوق-النشر"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حقوق النشر")]), _vm._v("©")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#شكر-وتقدير"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكر وتقدير")])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#أين-يمضي"
    }
  }, [_vm._v("1"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين يمضي")])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#على-أعتاب-القمر"
    }
  }, [_vm._v("2"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- على أعتاب القمر")])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#قال-لقمان-الحكيم"
    }
  }, [_vm._v("3"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قال لقمان الحكيم")])])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#غياب",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غياب")])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ذات-مصيبة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("5 - ذات "), _c('strong', [_vm._v("مصيبة")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#ألم-جميل",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("6 - ألم جميل")])])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#دمعة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دمعة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#همسة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- همسة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#غرام",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- غرام")])])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#دائما-أنت",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دائمًا أنت")])])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#همسة-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("11 - همسة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#ألوان",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("12 - ألوان")])])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#ضاعت",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("13 - ضاعت")])])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#أيها-الفجر-الجميل",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("14 - أيُّها الفجر الجميل")])])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#حلم-صغير",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("15 - حلم صغير")])])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#مرور",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("16 - مرور")])])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#ماذا-أقول-لأبي",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("17 - ماذا أقول لأبي؟")])])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#متأخرة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("18 - متأخرة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#يقول-صاحب-الأنف-الطويل",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يقول صاحب الأنف الطويل")])])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#خارج-القرار",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("20 - خارج القرار")])])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#قطعة-كونية",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("21 - قطعة كونية")])])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#بقايا-أمل",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("22 - بقايا أمل")])])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#تفاحة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("23 - تفاحة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#عناقيد",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("24 - عناقيد")])])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#اعتقال",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("25 - اعتقال")])])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#همسة-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("26 - همسة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#قالت",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("27 - قالت")])])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#كتبت",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتبت")])])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#يا-أنت",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يا أنت")])])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#قالت-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قالت")])])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#لست-جريئا-حتى-أنثر-الشهبا",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لستُ جريئًا حتى أنثر الشهبا")])])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#إلى-النور",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إلى النور")])])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#أحتاج-ضياعا-يهديني",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أحتاج ضياعًا يهديني")])])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#همسة-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- همسة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#همسة-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("همسة")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#همسة-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("همسة")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#همسة-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- همسة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#أمنية",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أمنية")])])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#دبي",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دبي")])])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#هاملت-متردد",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هاملت متردد")])])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#كتابة",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتابة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#بلسم",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- بلسم")])])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#سكتت-شهرزاد",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سكتَت شهرزاد")])])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#يا-لقلبي",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يا لَقلبي")])])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#أخبريني",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أخبريني")])])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#شكرا",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- شكرًا")])])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#في-عشقك",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- في عشقك")])])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#همس.-ليته",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- همس. ليتَه")])])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#مرصودة",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- مرصودة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#امرأة-تسكن-قلبي",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- امرأة تسكن قلبي")])])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#عيناك",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- عيناك")])])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#وداعا",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وداعًا")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0